import { Component, OnInit,Input,Output,EventEmitter   } from '@angular/core';

@Component({
    selector: 'app-checkswitch',
    templateUrl: './checkswitch.component.html',
    styleUrls: ['./checkswitch.component.css']
})
export class CheckswitchComponent implements OnInit {

    constructor() { }
    @Input() item: any = '';
    @Input() type: any = '';
    @Input() enabletype: any = 0;

    @Output() statusChange: EventEmitter<number> = new EventEmitter<number>();

    status: number = 0;

    ngOnInit(): void {
        this.init();
    }

    toggleStatus() {
        this.status = this.status == 1 ? 0 : 1;
        this.item['changestatus'] = this.status;
        this.item['act'] = this.type;
        this.statusChange.emit(this.item);
    }

    init(){
        if(this.enabletype == 1){
            this.status = this.item.is_enable;
        }else{
            this.status = this.item.status;
        }
    }
}
